export const getGlassStyles = (isDarkMode) => ({
  // CALM-PASS: Light → glass-light-card (kein backdrop-blur, kein Gradient-Tint)
  glassBackground: `absolute inset-0 ${isDarkMode
    ? 'bg-gradient-to-br from-gray-900/30 via-gray-800/20 to-gray-900/30 border border-white/20 backdrop-blur-2xl shadow-[0_8px_32px_rgba(0,0,0,0.4)]'
    : 'bg-white border border-slate-200 shadow-sm'
  } rounded-3xl`,

  // CALM-PASS: Light → leerer Overlay (rein dekorativ)
  glassOverlay: `absolute inset-0 ${isDarkMode
    ? 'bg-gradient-to-t from-white/5 via-transparent to-white/10'
    : ''
  } rounded-3xl`,

  // CALM-PASS: Light → solides bg-white, kein backdrop-blur
  inputGlassBackground: `absolute inset-0 ${isDarkMode
    ? 'bg-gray-800/30 border border-white/30 backdrop-blur-xl'
    : 'bg-white border border-slate-200'
  } rounded-2xl`,

  inputClassName: `relative w-full px-4 py-4 bg-transparent border-0 rounded-2xl focus:ring-2 ${
    isDarkMode ? 'focus:ring-blue-400/50' : 'focus:ring-brand/40'
  } focus:outline-none transition-all duration-300 ${
    isDarkMode ? 'text-white placeholder-white/60' : 'text-slate-900 placeholder-slate-400'
  }`,

  focusHighlight: `absolute inset-0 rounded-2xl border border-transparent ${
    isDarkMode ? 'group-focus-within:border-blue-400/50' : 'group-focus-within:border-brand/40'
  } transition-all duration-300 pointer-events-none`
});

export const getButtonStyles = (isDarkMode, type = 'primary') => {
  const baseStyles = {
    className: "relative group overflow-hidden rounded-2xl transition-all duration-300 transform hover:scale-[1.01] active:scale-[0.99]",
    hoverOverlay: "absolute inset-0 rounded-2xl transition-all duration-300 opacity-0 group-hover:opacity-100",
    waveEffect: "absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
  };

  if (type === 'primary') {
    return {
      ...baseStyles,
      style: {
        // CALM-PASS: Light → solides Brand-Blau, kein Glas
        background: isDarkMode
          ? 'linear-gradient(135deg, rgba(59,130,246,0.7) 0%, rgba(37,99,235,0.7) 50%, rgba(29,78,216,0.7) 100%)'
          : '#2563EB',
        backdropFilter: isDarkMode ? 'blur(20px)' : 'none',
        border: isDarkMode ? '1px solid rgba(255,255,255,0.3)' : 'none',
        boxShadow: isDarkMode
          ? '0 8px 32px rgba(59,130,246,0.4), inset 0 1px 0 rgba(255,255,255,0.2)'
          : 'none'
      },
      hoverStyle: {
        background: isDarkMode
          ? 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.08) 100%)'
          : 'rgba(255,255,255,0.12)'
      }
    };
  }

  return {
    ...baseStyles,
    style: {
      // CALM-PASS: Light → neutrales Slate, kein Glas
      background: isDarkMode
        ? 'linear-gradient(135deg, rgba(71,85,105,0.6) 0%, rgba(75,85,99,0.6) 50%, rgba(71,85,105,0.6) 100%)'
        : '#F1F5F9',
      backdropFilter: isDarkMode ? 'blur(20px)' : 'none',
      border: isDarkMode ? '1px solid rgba(255,255,255,0.3)' : '1px solid #E2E8F0',
      boxShadow: isDarkMode
        ? '0 8px 32px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.2)'
        : 'none'
    },
    hoverStyle: {
      background: isDarkMode
        ? 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.05) 100%)'
        : 'rgba(0,0,0,0.04)'
    }
  };
};